import { add, contains, qs, qsa, remove } from "@fluorescent/dom";
import carousel from "@/components/carousel";

const selectors = {
  slider: "[data-carousel]",
  wrappingContainer: ".complementary-products",
  complementaryProducts: "[data-complementary-products]",
  complementaryProductsContent: "[data-complementary-products-content]",
};

const classes = {
  hasSlider: "complementary-products__content--has-slider",
  hidden: "hidden",
};

const complementaryProducts = node => {
  const complementaryProducts = qsa(selectors.complementaryProducts, node);

  if (!complementaryProducts.length) return;

  let carousels = [];

  const {
    recommendationsType,
    productId: id,
    sectionId,
    layout,
    maxRecommendations,
  } = complementaryProducts[0].dataset;

  if (recommendationsType === "app-recommendations") {
    handleRecommendedProducts();
  } else {
    initSlider();
  }

  function handleRecommendedProducts() {
    const requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${maxRecommendations}&product_id=${id}&intent=complementary`;

    fetch(requestUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;

        const recommendations = qs(
          selectors.complementaryProductsContent,
          html
        );

        if (recommendations && recommendations.innerHTML.trim().length) {
          complementaryProducts.forEach(
            block => (block.innerHTML = recommendations.innerHTML)
          );

          // Remove hidden flag as content has been fetched
          complementaryProducts.forEach(block => {
            remove(block.closest(selectors.wrappingContainer), classes.hidden);
          });

          initSlider();
        }
      })
      .catch(error => {
        throw error;
      });
  }

  function initSlider() {
    if (layout !== "slider") return;

    complementaryProducts.forEach(block => {
      const sliderElement = qs(selectors.slider, block);

      if (contains(sliderElement, classes.hasSlider)) {
        carousels.push(carousel(block));
        add(block, "slider-enabled");
      }
    });
  }

  function unload() {
    carousels.forEach(carousel => carousel.destroy());
  }

  return { unload };
};

export default complementaryProducts;
